import React, { createRef } from 'react';
import { connect } from 'react-redux';
import { withStyles } from '@material-ui/core/styles';
import { withRouter, Link, Redirect } from 'react-router-dom';

import {
  showNavBarStory,
  showNavBarPrintStore,
  showNavBarModal
} from 'shared/actions/navActions';

import {
  setPhotoSwipeOpen,
  setPhotoSwipeIndex,
  setPhotoSwipeMomentId,
} from 'shared/actions/photoSwipeActions';

import PhotoSwipeWrapper from 'shared/components/PhotoSwipe';
import Modal from 'shared/components/Modal';
import PrintStore from 'shared/components/PrintStore';
import Image from 'shared/components/Image';
import GalleryInner from 'shared/components/Gallery';
import config from 'shared/config/config';

const windowWidth = window.innerWidth;
const isMobile = windowWidth < 960;

const styles = theme => ({
  container: {
    position: 'relative',
    marginTop: 0,
    transition: 'margin-top 0.5s'
  },
  content: {
    flexGrow: 1,
    padding: theme.spacing.unit * 3,
  },
  paper: {
    padding: `${theme.spacing.unit}px ${theme.spacing.unit * 2}px`,
  },
  card: {
    maxWidth: 345,
    maxHeight: 345,
    // minWidth: 200,
    // minHeight: 200,
  },
  media: {
    height: 300,
  },
  moments: {
    flexGrow: 1,
  },
  toolbar: {
    position: "fixed",
    bottom: theme.spacing.unit * 1,
    right: theme.spacing.unit * 1,
    left: theme.spacing.unit * 1,
    zIndex: 3
  },
  fab: {
    position: "relative",
    float: "right",
    color: "primary",
    // margin: theme.spacing.unit, // You might not need this now
    marginRight: "15px",
    marginBottom: "15px",
    background: '#3e387b'
  },
  progress: {
    margin: theme.spacing.unit * 2,
    size: 10,
  },
  coverContainer: {
    position: 'fixed',
    top: 0,
    left: 0,
    right: 0,
    width: '100%',
    //minHeight: '300vh',
    //zIndex: 1,
    transition: 'transform 1s ease-out',
    background: '#fff'
  },
  coverOverlay: {
    position: 'absolute',
    top: 0,
    left: 0,
    bottom: 0,
    right: 0,
    zIndex: 2,
    background: '#000',
    opacity: 0,
    transition: 'opacity 0.01s'
  },
  //coverFrame: {
  //  position: 'absolute',
  //  zIndex: 0,
  //  top: 0,
  //  left: 0,
  //  right: 0
  //},
  coverImage: {
    position: 'relative',
    zIndex: 1,
    backgroundPosition: "top center",
    backgroundSize: "105% auto",
    width: '100%',
    height: '100%',
    opacity: 0.9
  },
  coverHeaderWrapper: {
    position: 'relative',
    float: 'left',
    width: '100%',
    zIndex: 2
  },
  coverHeader: {
    position: 'relative',
    float: 'left',
    width: 'auto',
    zIndex: 9,
    opacity: 1,
    //left: '15px',
    //bottom: '15px',
    background: 'rgba(255, 255, 255, 1)',
    boxShadow: '0 0 3px rgba(0, 0, 0, 0.2)',
    borderRadius: '3px',
    fontSize: '1rem !important',
    padding: '10px',
    fontWeight:'400 !important',
    //margin: 0,
    margin: '-10px 5px 5px'
  },
  gallery: {
    float: isMobile ? 'left' : 'right',
    width: isMobile ? '100%' : 'calc(80vw - 17px)',
    position: 'relative',
    zIndex: 2,
    paddingBottom: isMobile ? '65px' : 0
  },
  editIcon: {
    fontSize: '20px',
    marginTop: '-4px',
    marginLeft: '5px',
    cursor: 'pointer'
  },
  helpText: {
    display: 'block',
    fontSize: '1.1rem',
    margin: '1.5rem 0',
    color: '#333'
  },
  editForm: {
    position: 'relative',
    zIndex: 2,
    width: '100%',
    background: '#fff',
    padding: '2rem 1rem',
    margin: '20vh auto 0',
    boxShadow: '3px 3px 20px rgba(0, 0, 0, 0.5)',
    maxWidth: '600px',
    borderRadius: isMobile ? 0 : '3px'
  },
  editFormBackdrop: {
    position: 'fixed',
    zIndex: 1,
    top: 0,
    left: 0,
    right: 0,
    bottom: 0,
    background: 'linear-gradient(rgba(0, 0, 0, 0), rgba(0, 0, 0, 0.5))'
  },
  closeIcon: {
    position: 'absolute',
    top: '5px',
    right: '5px',
    color: '#949494',
    opacity: 0.5,
    cursor: 'pointer',
    '&:hover': {
      opacity: 1
    }
  },
  backIcon: {
    display: isMobile ? 'inline' : 'none',
    position: 'fixed',
    zIndex: 3,
    top: '0.5rem',
    left: '0.5rem',
    color: '#fff',
    width: '2rem',
    height: '2rem',
    fontSize: '2rem',
    opacity: 0.7
  }
});

class Gallery extends React.Component {
  constructor(props) {
    super(props);

    // for moments, track each index
    this.fadeInApplied = {};

    this.state = { 
      printStoreOpen: false
    };
  }

  componentDidMount() {
    if (window.location.search.match(/open=true/)) {
      this.props.setPhotoSwipeOpen(true);
    }
  }

  handlePhotoSwipeClose = () => {
    const scrollNode = this.props.scrollNode && this.props.scrollNode.current;
    if (scrollNode && window.savedScroll) {
      scrollNode.scrollTop = window.savedScroll;
    }

    const event = new CustomEvent('show-moments');
    document.body.dispatchEvent(event);
  }

  openPrintStore() {
    this.setState({printStoreOpen: true});
    this.props.showNavBarPrintStore();
  }

  closePrintStore() {
    this.setState({printStoreOpen: false});
    this.props.showNavBarStory();
  }

  getCachedMoments() {
    const { moments: { allIds, byId } } = this.props;

    if (allIds) {
      return allIds.map(id => byId[id]).sort((a, b) => a.position < b.position);
    }

    return [];
  }

  renderPrintStore() {
    const { gallery } = this.props;
    if (gallery) {
      return (
        <Modal
          disableScrollbar={true}
          isOpen={this.state.printStoreOpen}
          close={this.closePrintStore.bind(this)}>
          <PrintStore url={gallery.print_store_url} />
        </Modal>
      );
    }

    return null;
  }

  render() {
    const { classes, gallery } = this.props;
    if (!classes || !gallery) {
      return null;
    }

    const moments = this.getCachedMoments();

    let maxResolution = 3;
    if (windowWidth <= 960) {
      maxResolution = 1;
    }
    if (windowWidth <= 1280) {
      maxResolution = 2;
    }

    let columns = isMobile ? 2 : 3;

    let galleryJsx = (
      <GalleryInner 
        index={0}
        resolution={0}
        maxResolution={maxResolution}
        progressive={true}
        direction={"column"}
        columns={columns}
        //onClick={this.handleClickMoment}
        initVisible={true}
        forceVisible={true}
        //scrollNode={this.props.scrollNode}
        moments={moments}
      />
    );

    let psWrapper = (
      <PhotoSwipeWrapper
        storyId={0}
        onClose={this.handlePhotoSwipeClose}
        printStoreUrl={gallery.print_store_url}
        showPrintStore={this.state.showPrintStore}
        passMomentToPrintStore={gallery.append_store_moment}
      />
    );

    const style = {};
    if (this.props.selectionEnabled) {
      style.zIndex = 9998;
      style.marginTop = '100px';
    }

    return (
      <div className={classes.container} style={style}>
        {psWrapper}
        <div className={classes.gallery}>
          {galleryJsx}
        </div>
      </div>
    );
  }
}

const mapStateToProps = state => ({
  gallery: state.galleryReducer.gallery,
  moments: state.galleryReducer.moments,
  selectionEnabled: state.selectionReducer.selection.enabled
});

export default connect(mapStateToProps, { })(withStyles(styles, { withTheme: true })(withRouter(Gallery)));
